import React from 'react';
import classnames from 'classnames';
import InfiniteScroll from 'v2/common/InfiniteScroll/InfiniteScroll';
import styles from './DataProductsList.module.scss';
import DataProductItem from './DataProductItem';
import { DjangoListResponse, WithInfiniteQuery, DataProduct } from 'v2/models';
import DataSetActions from 'v2/common/DRM/DataProduct/DataSetActions/DataSetActions';

type DataProductsListProps = WithInfiniteQuery<
  DjangoListResponse<DataProduct>
> & {
  selected: DataProduct | null;
  onSelect: (dataProduct: DataProduct) => void;
  onChange: () => void;
  onDelete: (id: number) => void;
};

const DataProductsList = ({
  data,
  infiniteQueryFetch,
  selected,
  onSelect,
  onChange,
  onDelete,
}: DataProductsListProps) => {
  return (
    <>
      <div
        className={classnames(
          styles.dataProductListHeader,
          styles.columnCount_2
        )}
        data-cy="datasets:list-header"
      >
        <p>Name</p>
        <p>Renewal date</p>
      </div>
      <div
        className={classnames(styles.dataProductListContainer)}
        data-cy="datasets:list-content"
      >
        {data.pages.map((page) => (
          <React.Fragment key={page.next}>
            {page.results.map((dataProduct) => {
              return (
                <DataProductItem
                  key={dataProduct.id}
                  dataProduct={dataProduct}
                  onClick={(item) => onSelect(item)}
                  isSelected={!!(selected && selected.id === dataProduct.id)}
                  actions={
                    <DataSetActions
                      dataSet={dataProduct}
                      label="⋮"
                      showMenuArrow={true}
                      onChange={onChange}
                      onDelete={onDelete}
                    />
                  }
                />
              );
            })}
          </React.Fragment>
        ))}
      </div>
      <InfiniteScroll
        callback={() => infiniteQueryFetch.fetchNextPage()}
        isLoading={infiniteQueryFetch.isFetching}
        disabled={!infiniteQueryFetch.hasNextPage}
        scrollThreshold={500}
      />
    </>
  );
};

export default DataProductsList;
